import styled from 'styled-components';
import StyledPagination from 'StyledPagination.js';
import {Input, Button} from 'global/styles/styles.js';
import { rem } from 'polished';

const baseFont = '12px';

const FontFamily = ({theme: {$fontFamily}}) => `${$fontFamily}`;
const VisuallyHidden = ({theme:{visuallyHidden}}) => visuallyHidden();

const S = {};

S.AccountWallet = styled.div`
    width: 100%;
    margin: 0 auto;
    font-family: ${FontFamily};
    
    ${StyledPagination.Pagination}{
      margin-bottom: 20px; 
    }
`;

S.WalletTransactionsList = styled.div`
    margin: 10px auto 0;
    width: 100%;
`;

S.NoResult = styled.div`
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

S.WalletTransactionsListItem = styled.div`
display: flex;
height: 52px;
&>div {
	border: none;
	font-size: 11px; 
	color: rgba(0, 0, 0, 0.87);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: flex;
	justify-content: center;
	align-items: center;
	
	&.wallet-toggle {
	  justify-content: flex-start;
	  flex: 1;
	  padding-left: 20px; 
	}
	
	&.wallet-status {
		width: 15%;
		&.red{
		    & .status-icon{
		        background-image: url(/images/svg/status_red.svg);
		    }
		}
		&.green{
		    & .status-icon{
		      background-image: url(/images/svg/status_green.svg);
		    }
		}
	    &.gray{
		    & .status-icon {
		      background-image: url(/images/svg/status_gray.svg);
		      width: 25px; 
              height: 25px;
              background-position-x: -1px; 
		    }
		}
		
		& .status-icon {
		    width: 20px;
            height: 20px;
            background-color: transparent;
            background-position: 0 0;
            background-size: cover;
		}
	}
	
	&.wallet-type {
	  width: 30%;
	  text-align: center;
	  white-space: normal;
	}
	
	&.wallet-amount {
		width: 18%;
		font-weight: 600;
		font-size: 13px;
		
		& .currency {
		font-size: 13px;
		margin-left: 3px;
		}
	}
	
	&.wallet-date {
		width: 18%;
		display: flex;
	}
}
`;

S.WalletTransactionsListItemDetails = styled.div`
    width: 100%;
    position: relative;
    max-height: 0;
    transition-property: max-height;
    transition-duration: .5s;
    overflow: hidden;

    & .details-wrapper {
      text-align: center;

      & .middle-row {
        display: flex;
        justify-content: space-around;
        margin-top: 24px;
        margin-bottom: 14px;

        & > div {
          flex: 1;
        }
      }

      & .last-row {
        margin-bottom: 14px;
      }
    }

    ${({isOpen}) => {
    return isOpen == true && 'max-height: 400px';  
    }

}
`;

S.WalletTransactions = styled.div`
margin: 0 16px;
`;

S.WalletTransactionsListItemWrapper = styled.div`
margin-bottom: 2px;
`;

S.FakeTableHead = styled.div`
    display: flex;
    border-bottom: 2px solid #D32F2F;
    padding-bottom: 5px;
    margin-bottom: 14px;
    
    & > div{
        color: rgba(0, 0, 0, 0.87);
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        line-height: 1;
        border-top: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        &.wallet-toggle {
            flex:1 ;
        }
        &.wallet-type{
           width: 30%;
         
         }
           &.wallet-amount{
              width: 18%;
       
           }
           &.wallet-date{
               width: 18%;
           }
              &.wallet-status{
               width: 15%;
           }
    }
`;

S.WalletFilters = styled.div`
    display: flex;
    flex-direction: column;
`;

S.WalletFiltersTop = styled.div`
display: flex;
flex-direction: column;
background-color: #fff;
 `;
 
S.WalletFiltersBottom = styled.div`
display: flex;
padding: 17px 16px;
background-color:#fff;
`;

S.WalletFiltersDates = styled.div`
    display: flex;
    margin: 0 16px 20px 16px;
`;

S.DateLabel = styled.div`
    display: flex;
    font-weight: 400;
    color: ${({theme:{$datepickerLabelColor}})=> $datepickerLabelColor};
    background-color: ${({theme:{$datepickerLabelBg}})=> $datepickerLabelBg};
    padding-left: 0.75rem;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: 14px;
`;

S.DateIcon = styled.i`
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    height: 100%;
    width: 33px;
    font-size: 1.67rem;
    color: #565656;
    justify-content: center;
    align-items: center;
    pointer-events: none;
`;

S.WalletFiltersBtns = styled.div`
    display: flex;
    flex: 1;
    background-color: #EFF2F3;
    padding: 20px 8px;
`;

S.FilterBtn = styled(Button)`
    font-family: ${FontFamily};
    width: 145px;
    flex-grow: 1;
    font-size: 16px;
    font-weight: 600;
    margin-top: 0;
    height: 36px;
    background-color: ${({isActive})=>(isActive == true ? '#D32F2F ': '#fff')};
    color:  ${({isActive})=>(isActive == true ? '#fff ': 'rgba(0, 0, 0, 0.87)')};
    padding: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    border-radius: 2px;
    display: block;
    justify-content: center;
    align-items: center;
    position: relative;
    white-space: nowrap;
    margin-right: 5px;
    &:last-of-type{
    margin-right: 0;
    }
`;

S.RadioButtons = styled.div`
  display: flex;
`;

S.RadioButton = styled.label`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

S.RadioButtonText = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-size:  12px;
  line-height: 1;
`;

S.RadioButtonControlIndicator = styled.div`
  border-radius: 50%;
  background-color: #fff;
  border: 2px solid ${({theme:{$accountWalletRadioButtonBorder}}) => $accountWalletRadioButtonBorder};
  position: relative;
  width: 18px;
  height: 18px;
  margin-right: 10px;
  flex-shrink: 0;
  cursor: pointer;
  
  &:before{
    position: absolute;
    content: '';
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    background-color: #fff;
    width: 6px;
    height: 6px;
    display: none;
    border-radius: 50%;
  }
`;

S.RadioButtonInput = styled(Input)`
   ${VisuallyHidden};
  
   &:checked,
   &.active{
     & + ${S.RadioButtonControlIndicator}{
      background-color: #D32F2F;
      &:before{
         display: block;
      }
   }
   }
`;

S.FakeTableBody = styled.div`

& > ${S.WalletTransactionsListItemWrapper}{
  &:nth-child(odd){
    background-color: #fff;
  }
  &:nth-child(even){
  background-color: rgba(255, 255, 255, 0.6);
  }
}
  
`;

S.ArrowIcon = styled.div`
  cursor: pointer;
  width: 16px;
  height: 16px;
  transition: transform 0.2s linear;
  transform: ${({isOpen})=>(isOpen==true? 'rotate(180deg)': 'rotate(0deg)')};
  & svg{
    width: 100%;
  }
`;

S.ItemDetailsTitle = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-weight: 600;
  font-size: 13px;
`;

S.ItemDetailsHeader = styled.div`
 color: rgba(0, 0, 0, 0.87);
 text-transform: uppercase;
 font-size: 11px;
 white-space: nowrap;
 text-overflow: ellipsis;
 overflow:hidden;
 width: 100%;
 text-align: center;
  margin-bottom: 2px;
`;

S.ItemDetailsBody = styled(S.ItemDetailsHeader)`
 font-size: 12px;
 text-transform: none;
 margin-bottom: 0;
 &.red{
 color: red;
 }
 &.green{
 color: green;
 }
`;

S.Datepicker = styled.div`
   position: relative;
   display: flex;
   height: 42px;
   width: 100%;
   border: 1px solid rgba(0, 0, 0, 0.24);
   border-radius: 3px;

   &:first-child {
    margin-right: 10px;
   }

   input[type="date"] {
    -o-appearance: none;
    -ms-appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    flex: 1 1 0%;
    padding: 0;
    padding-left: 10px;
    background-color: ${({theme:{$datepickerInputBg}})=> $datepickerInputBg};
    border: none;
    border-radius: 0;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    color: ${({theme:{$datepickerInputColor}})=> $datepickerInputColor};
    outline: none;

    &::-webkit-calendar-picker-indicator {
        padding: 0;
        opacity: 0;
        margin: 0;
    }
   }
`;

S.CancellPayoutBtn = styled(Button)`
 width: ${rem('80px', baseFont)};
 height: ${rem('20px', baseFont)};
 background-color: #D32F2F;
 color: #fff;
 border-radius: 4px;
`;

S.ConfirmModal = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    color: #000;
`;

S.BellContainer = styled.div`
   display: flex;
   width: 100%;
   margin: 20px auto 20px auto;
`;

S.BtnsWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

S.ButtonCancel = styled(Button)`
    border: 1px solid ${({theme:{$accountProfileBonusModalsAcceptBttnColor}})=> $accountProfileBonusModalsAcceptBttnColor};
    height: 2.625rem;
    border-radius: 0.1875rem;
    box-shadow: none;
    padding: 0 0.75rem;
    margin-top: 1rem;
    flex: 1;
    background: ${({theme:{$accountProfileBonusModalsSuccessBttnBg}})=> $accountProfileBonusModalsSuccessBttnBg};
    color: ${({theme:{$accountProfileBonusModalsAcceptBttnColor}})=> $accountProfileBonusModalsAcceptBttnColor};
   
`;
S.ButtonAccept = styled(S.ButtonCancel)`
    margin-right: 0;
    border: 1px solid ${({theme:{$accountProfileBonusModalsAcceptBorderBttnBg}})=> $accountProfileBonusModalsAcceptBorderBttnBg};
    color: #fff;
    margin-right: 1rem;
    background: ${({theme:{$accountProfileBonusModalsCancelBttnBg}})=> $accountProfileBonusModalsCancelBttnBg};
`;

S.BellIcon = styled.div`
    width: 30px;
    height: 30px;
    margin: auto;
    display: flex;
     & svg {
       width: 100%;
        & .a {
            fill: #c62828 !important;
        }
    }
`;

S.Description = styled.div`
    text-align: center;
    display: flex;
    color: #000;
`;

export default S;